import { GetQuestionListForMyQuestionResponse } from '../types/Question.api.type';
import { Card, CardHeader } from './ui/card';
import { Badge } from './ui/badge';
import { getCategoryEmoji, getCategoryName } from '../util/category.util';
import { ClockIcon, UserIcon } from './ui/icons';
import { formatTimeAgo, remainingQuestionTime } from '../util/DateUtil';

interface MyQuestionProps {
  pagingQuestion: GetQuestionListForMyQuestionResponse;
}

/**
 * 유저 대시보드 -> 내 설문 모아보기
 *
 * @description
 *
 * @author hjkim
 * @constructor
 */
const MyQuestion = ({ pagingQuestion }: MyQuestionProps) => {
  return (
    <div>
      {pagingQuestion.questions.map((question) => (
        // <QuestionCardCustom question={question} />
        <Card
          key={question.questionId}
          className={`${question.isExpired ? '' : ''} transition-all duration-200 hover:shadow-lg hover:shadow-primary/5 hover:-translate-y-1 cursor-pointer group mb-4`}>
          <CardHeader className="pb-4">
            <div className="space-y-3">
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-2 flex-wrap">
                  <Badge className="flex items-center gap-1 text-xs h-6 group-hover:bg-primary/10 transition-colors">
                    <span>{getCategoryEmoji(String(question.categoryId))}</span>
                    <span className="">{getCategoryName(String(question.categoryId))}</span>
                    {/*<span className="xs:hidden">*/}
                    {/*  {getCategoryName(String(question.categoryId)).slice(0, 2)}*/}
                    {/*</span>*/}
                  </Badge>
                  {question.isExpired ? (
                    <Badge
                      variant="secondary"
                      className="flex items-center gap-1 text-xs bg-gray-100 text-gray-600 h-6">
                      <span>🏁</span>
                      <span className="hidden xs:inline">종료됨</span>
                    </Badge>
                  ) : (
                    <Badge
                      variant="outline"
                      className={`flex items-center gap-1 text-xs ${
                        remainingQuestionTime(question.endDate).includes('분') &&
                        !remainingQuestionTime(question.endDate).includes('시간') &&
                        !remainingQuestionTime(question.endDate).includes('일')
                          ? 'border-red-300 text-red-600 bg-red-50'
                          : 'border-green-300 text-green-600 bg-green-50'
                      }`}>
                      <ClockIcon className="w-3 h-3" />
                      <span>{remainingQuestionTime(question.endDate)}</span>
                    </Badge>
                  )}
                </div>
                {/* 작성자 정보 */}
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-primary/15 transition-colors">
                  {question.userProfileImageUrl ? (
                    <img
                      src={question.userProfileImageUrl}
                      alt={question.userProfileImageUrl}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                  ) : (
                    <UserIcon className="w-4 h-4 text-primary" />
                  )}
                </div>
                <div className="flex flex-col min-w-0">
                  <span className="text-sm font-medium text-fore-ground truncate">{question.username}</span>
                  <span className="text-xs text-muted-foreground">{formatTimeAgo(question.endDate)}</span>
                </div>
              </div>
              {/* 설문 제목 */}
              <h3
                className={`leading-relaxed font-medium ${question.isExpired ? 'text-gray-600' : 'text-fore-ground group-hover:text-primary'}`}>
                {question.questionTitle}
              </h3>
            </div>
          </CardHeader>
        </Card>
      ))}
    </div>
  );
};

export default MyQuestion;
